import React, { useEffect, useState } from "react"
import { BiInfoCircle } from "react-icons/bi"
import { HiOutlineGlobeAlt } from "react-icons/hi"
import { ReactMarkdown } from "react-markdown/lib/react-markdown"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

import ConfirmationModal from "../components/Common/ConfirmationModal"
import Footer from "../components/Common/Footer"
import RatingStars from "../components/Common/RatingStars"
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import CourseDetailsCard from "../components/core/Course/CourseDetailsCard"
import { formatDate } from "../services/formatDate"
import { fetchCourseDetails } from "../services/operations/courseDetailsAPI"
import { BuyCourse, verifyCoupon } from "../services/operations/studentFeaturesAPI"
import GetAvgRating from "../utils/avgRating"
import Error from "./Error"
import UserBillingDetails from "../components/Common/userBillingDetails"

function CourseDetails() {
  const { user } = useSelector((state) => state.profile)
  const { token } = useSelector((state) => state.auth)
  const { loading } = useSelector((state) => state.profile)
  const { paymentLoading } = useSelector((state) => state.course)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [promo, setPromo] = useState('');
  const [promoApplied, setPromoApplied] = useState(false);
  const [discountedPrice, setDiscoutedPrice] = useState(0);
  const [promoLoading, setPromoLoading] = useState(false);
  const [billingDetailsModal, setBillingDetailsModal] = useState(false);
  // Getting courseId from url parameter
  const { courseId } = useParams()
  // console.log(`course id: ${courseId}`)

  // Declear a state to save the course details
  const [response, setResponse] = useState(null)
  const [confirmationModal, setConfirmationModal] = useState(null)
  useEffect(() => {
    // Calling fetchCourseDetails fucntion to fetch the details
    ;(async () => {
      try {
        const res = await fetchCourseDetails(courseId)
        // console.log("course details res: ", res)
        setResponse(res)
      } catch (error) {
        console.log("Could not fetch Course Details")
      }
    })()
  }, [courseId])

  // console.log("response: ", response)

  // Calculating Avg Review count
  const [avgReviewCount, setAvgReviewCount] = useState(0)
  useEffect(() => {
    const count = GetAvgRating(response?.data?.courseDetails.ratingAndReviews)
    setAvgReviewCount(count)
  }, [response])
  // console.log("avgReviewCount: ", avgReviewCount)

  // // Collapse all
  // const [collapse, setCollapse] = useState("")
  const [isActive, setIsActive] = useState(Array(0))
  const handleActive = (id) => {
    // console.log("called", id)
    setIsActive(
      !isActive.includes(id)
        ? isActive.concat([id])
        : isActive.filter((e) => e != id)
    )
  }

  // Total number of lectures
  const [totalNoOfLectures, setTotalNoOfLectures] = useState(0)
  useEffect(() => {
    let lectures = 0
    response?.data?.courseDetails?.courseContent?.forEach((sec) => {
      lectures += sec.subSection.length || 0
    })
    setTotalNoOfLectures(lectures)
  }, [response])

  if (loading || !response) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    )
  }
  if (!response.success) {
    return <Error />
  }

  const {
    _id: course_id,
    courseName,
    courseDescription,
    thumbnail,
    price,
    whatYouWillLearn,
    courseContent,
    ratingAndReviews,
    instructor,
    studentsEnroled,
    createdAt,
  } = response.data?.courseDetails

  const handleBuyCourse = (billingDetails) => {
    if (token) {
      BuyCourse(token, [courseId], user,promoApplied ? promo: '',billingDetails, navigate, dispatch)
      return
    }
    setConfirmationModal({
      text1: "You are not logged in!",
      text2: "Please login to Purchase Course.",
      btn1Text: "Sign up",
      btn2Text: "Cancel",
      btn1Handler: () =>{localStorage.setItem('courseIdBuy', courseId); navigate("/signup")},
      btn2Handler: () => setConfirmationModal(null),
    })
  }

  if (paymentLoading) {
    // console.log("payment loading")
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    )
  }

 const handleApplyPromo = async ()=>{
    setPromoLoading(true);
    let discount = await verifyCoupon(promo, course_id);
    if(discount){
      setPromoApplied(true);
      let newPrice = +price - (+price * (+discount/100));
      setDiscoutedPrice(newPrice.toFixed(2));
    }
    setPromoLoading(false);

 }

 const handleGetBillingDetails = async ()=>{
  if(token){
    setBillingDetailsModal(true);
    return;
  }
  setConfirmationModal({
    text1: "You are not logged in!",
    text2: "Please login to Purchase Course.",
    btn1Text: "Sign up",
    btn2Text: "Cancel",
    btn1Handler: () =>{localStorage.setItem('courseIdBuy', courseId); navigate("/signup")},
    btn2Handler: () => setConfirmationModal(null),
  })
 }

 const billingDetailsSubmitted = (billing_details)=>{
  let billingDetails = ({...billing_details, address: {city: billing_details.city, state: billing_details.state, stateCode: billing_details.stateCode, street:billing_details.street}});
  setBillingDetailsModal(false);
  handleBuyCourse(billingDetails);
 }  
  return (
    <>
      {billingDetailsModal && <UserBillingDetails user={user} onSubmit={billingDetailsSubmitted} setBillingDetailsModal={setBillingDetailsModal}/>}
      <div className={`relative w-full bg-[#dbb4ac] bx-wrapper`}>
        {/* Hero Section */}
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={thumbnail}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>
            <div
              className={`z-11 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-[white]`}
            >
              <div>
                <p className="text-4xl font-bold text-[white] sm:text-[42px]">
                  {courseName}
                </p>
              </div>
              <p className={`text-[white]`}>{courseDescription}</p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-[yellow]">{avgReviewCount}</span>
                <RatingStars Review_Count={avgReviewCount} Star_Size={24} />
                <span>{`(${ratingAndReviews.length} reviews)`}</span>
                <span>{`${studentsEnroled.length} students enrolled`}</span>
              </div>
              <div>
                <p className="">
                  Created By {`${instructor.firstName} ${instructor.lastName}`}
                </p>
              </div>
              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at {formatDate(createdAt)}
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> Hindi
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblack-500 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblack-5">
                {promoApplied ?(<> <del className="font-light">Rs.  {price}</del>  Rs. {discountedPrice} </>  ): 'Rs. ' + price}
              </p>
              {(!user || !studentsEnroled.includes(user?._id)) &&(  <div className="flex gap-2">
            <input type="text" value={promo} className="rounded-md text-center bg-[#161d29]" style={{color:'whitesmoke'}} onInput={(e)=>setPromo(e.target.value)} placeholder="Add Promo code" disabled={promoApplied}/>
            <button
              className="yellowButton w-full"
              onClick={
                ()=>{handleApplyPromo()}
              }
              disabled={promoApplied || promoLoading}
            >
             {promoLoading ? 'loading' : promoApplied ? 'Applied' : 'Apply'}
            </button>
          </div>)}

              <button className="yellowButton" onClick={ user && studentsEnroled.includes(user?._id)
                  ? () => navigate("/dashboard/enrolled-courses")
                  : ()=> handleGetBillingDetails()}>
              {user && studentsEnroled.includes(user?._id)
                ? "Go To Course"
                : "Buy Now"}
              </button>
              {(!user || !studentsEnroled.includes(user?._id)) && (<button className="blackButton">Add to Cart</button>)}
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[1rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCard
              course={response?.data?.courseDetails}
              setConfirmationModal={setConfirmationModal}
              handleGetBillingDetails={handleGetBillingDetails}
              handleApplyPromo = {handleApplyPromo}
              promoLoading = {promoLoading}
              setPromo={setPromo}
              discountedPrice={discountedPrice}
              promoApplied={promoApplied}
              promo = {promo}
            />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-[#313131] lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblack-600 p-8">
            <p className="text-3xl font-semibold">What you'll learn</p>
            <div className="mt-5">
              <ReactMarkdown>{whatYouWillLearn}</ReactMarkdown>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Content</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {courseContent.length} {`section(s)`}
                  </span>
                  <span>
                    {totalNoOfLectures} {`lecture(s)`}
                  </span>
                  <span>{response.data?.totalDuration} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4">
              {courseContent?.map((course, index) => (
                <CourseAccordionBar
                  course={course}
                  key={index}
                  isActive={isActive}
                  handleActive={handleActive}
                />
              ))}
            </div>

            {/* Author Details */}
            <div className="mb-12 py-4">
              <p className="text-[28px] font-semibold">Author</p>
              <div className="flex items-center gap-4 py-4">
                <img
                  src={
                    instructor.image
                      ? instructor.image
                      : `https://api.dicebear.com/5.x/initials/svg?seed=${instructor.firstName} ${instructor.lastName}`
                  }
                  alt="Author"
                  className="h-14 w-14 rounded-full object-cover"
                />
                <p className="text-lg">{`${instructor.firstName} ${instructor.lastName}`}</p>
              </div>
              <p className="text-richblack-50">
                {instructor?.additionalDetails?.about}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    </>
  )
}

export default CourseDetails
